import { Body } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';
import { Link } from '@cognite/cogs-core-v11/components/link/link.tsx';

type MigrationConfirmationContentProps = {
  inputValue: string;
};

export const MigrationConfirmationContent = ({
  inputValue,
}: MigrationConfirmationContentProps) => {
  return (
    <Body>
      Pressing &apos;Save&apos; will cause all application data associated with
      this location to be stored in and fetched from the {inputValue} space.
      Make sure users in this location have access to the new space before
      proceeding.
      <br />
      <br />
      Any existing application data on this location must be migrated manually.
      CDF transformations for this can be found{' '}
      <Link
        target="_blank"
        href="https://github.com/cognitedata/apm_datamodels/tree/main/transformations/infield/migrate_app_data_to_new_space"
      >
        here
      </Link>
      .
    </Body>
  );
};
